module.exports = "<atn-list-box\r\n  #list\r\n  name=\"Categorias\"\r\n  outputField=\"name\"\r\n  [service]=\"dataService\"\r\n  [sortable]=\"true\"\r\n></atn-list-box>\r\n\r\n<category-form\r\n  *ngIf=\"list.showForm\"\r\n  [id]=\"list.selectedItemId\"\r\n  (onSave)=\"list.hideFormAndReload()\"\r\n  (onDuplicate)=\"list.hideFormAndReload()\"\r\n  (onRemove)=\"list.hideFormAndReload()\"\r\n  (onBack)=\"list.hideForm()\"\r\n></category-form>\r\n"


//////////////////
// WEBPACK FOOTER
// ./libs/atenea-cms-brand/src/categories/category-list/category-list.component.html
// module id = ./libs/atenea-cms-brand/src/categories/category-list/category-list.component.html
// module chunks = main